var React = require('react');

function CircleLargePartBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M90,0v90H0c0,0,0,0,0,0c0,49.707,40.294,90,90,90c49.705,0,90-40.293,90-90C180,40.294,139.705,0,90,0z"}));
}

CircleLargePartBack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"180px","height":"180px","viewBox":"0 0 180 180","enableBackground":"new 0 0 180 180","xmlSpace":"preserve"};

module.exports = CircleLargePartBack;

CircleLargePartBack.default = CircleLargePartBack;
